import styled from "styled-components";
import { Colors } from "../../Styles/colors";

export const Button = styled.button`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    &:hover {
        background-color: ${Colors.primary.orange}
    }
    text-decoration:none;
    color: #FFFFFF;
    border-radius:4px;
    transition:all 0.4s ease-out;
    padding:0.5rem 1rem;
    @media screen and (max-width:960px) {
        width:100%;
        display:table;
        padding:0.5rem;
        text-align:center;
    }
`;